module.exports = __webpack_public_path__ + "static/media/Otro.35246d1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/NoAvailable/Otro.svg
// module id = 1821
// module chunks = 0